import $ from 'jquery';

const ACTIVE = 'active';

const filter = () => {
  const content = $('.js-filter-content');
  const items = content.find('.c-politician__list-item');
  const filterBtn = $('.js-filter-politician-btn');
  const select = $('.js-filter-select');
  const input = $('.js-filter-input');
  const az = $('.js-filter-az');
  const rank = $('.js-rank');

  const sortDefault = () => {
    items.show();
    rank.removeClass(ACTIVE);
    items.detach().sort((a, b) => {
      const textA = a.getAttribute('data-politician-lastname');
      const textB = b.getAttribute('data-politician-lastname');
      return textA > textB ? 1 : -1;
    });
    content.append(items);
  };

  filterBtn.on('click', ev => {
    ev.preventDefault();
    const curr = ev.currentTarget;
    if (!curr.classList.contains(ACTIVE)) {
      sortDefault();
      const self = $(curr);
      select.val('');
      const dataFilter = self.data('filter');

      az.removeClass(ACTIVE);
      if (self.hasClass(ACTIVE)) {
        items.show();
      } else {
        items.hide();
        content.find(dataFilter).show();
        filterBtn.removeClass(ACTIVE);
      }

      self.toggleClass(ACTIVE);
    }
  });

  select.on('change', ev => {
    sortDefault();
    az.removeClass(ACTIVE);
    filterBtn.removeClass(ACTIVE);
    const val = ev.target.value;
    if (val !== '*') {
      items.hide();
      content.find(`.${val}`).show();
    } else {
      items.show();
    }
  });

  input.on('input', ev => {
    sortDefault();
    const val = ev.target.value;
    if (val.length) {
      select.val('');
      filterBtn.removeClass(ACTIVE);
      az.removeClass(ACTIVE);
      items.hide();
      content.find(`[data-politician-name*="${val.toLowerCase()}"]`).show();
    } else {
      items.show();
    }
  });

  az.on('click', ev => {
    ev.preventDefault();
    sortDefault();
    const self = $(ev.target);
    const dataFilter = self.data('range').split(',');

    input.val('');
    if (self.hasClass(ACTIVE)) {
      items.show();
    } else {
      az.removeClass(ACTIVE);
      items.hide();
      select.val('');
      filterBtn.removeClass(ACTIVE);
      items.each((i, el) => {
        const lastname = el.getAttribute('data-politician-lastname');
        if (dataFilter.includes(lastname[0])) {
          $(el).show();
        }
      });
    }

    self.toggleClass(ACTIVE);
  });

  rank.on('click', ev => {
    ev.preventDefault();
    const self = $(ev.target);
    input.val('');
    select.val('');
    az.removeClass(ACTIVE);
    filterBtn.removeClass(ACTIVE);
    items.show();
    rank.removeClass(ACTIVE);
    self.toggleClass(ACTIVE);
    const dataRank = self.data('rank');
    items.detach().sort((a, b) => {
      const textA = a.querySelector('.c-politician__list-item-percent')
        .innerText;
      const percentageA = parseInt(textA, 10) / 100;
      const textB = b.querySelector('.c-politician__list-item-percent')
        .innerText;
      const percentageB = parseInt(textB, 10) / 100;
      if (dataRank === 'desc') {
        return percentageB > percentageA ? 1 : -1;
      }
      return percentageB < percentageA ? 1 : -1;
    });
    content.append(items);
  });

  // rank filters
  const currFilter = {
    category: 'all',
    chamber: '.house',
    order: 'desc',
  };

  const applyCurrFilters = () => {
    content
      .removeClass((index, className) =>
        (className.match(/(^|\s)category--\S+/g) || []).join(' '),
      )
      .addClass(`category--${currFilter.category}`);

    items.hide();
    content.find(currFilter.chamber).show();

    items.detach().sort((a, b) => {
      const valA = parseInt(
        a
          .querySelector(`.${currFilter.category} [data-percent]`)
          .getAttribute('data-percent'),
        10,
      );
      const valB = parseInt(
        b
          .querySelector(`.${currFilter.category} [data-percent]`)
          .getAttribute('data-percent'),
        10,
      );
      if (currFilter.order === 'desc') {
        if (valA === valB) {
          const textA = a.getAttribute('data-politician-lastname');
          const textB = b.getAttribute('data-politician-lastname');
          return textA > textB ? 1 : -1;
        }
        return valA < valB ? 1 : -1;
      }
      return valA < valB ? -1 : 1;
    });
    content.append(items);
  };

  const filterChamber = $('.js-filter-chamber');
  filterChamber.on('click', ev => {
    ev.preventDefault();
    const curr = ev.currentTarget;
    if (!curr.classList.contains(ACTIVE)) {
      const chamber = curr.getAttribute('data-filter');
      currFilter.chamber = chamber;
      filterChamber.removeClass(ACTIVE);
      curr.classList.add(ACTIVE);
      applyCurrFilters();
    }
  });

  const categoryForm = $('.js-category-form');
  const filterTop = $('.js-filter-top');
  if (categoryForm.length) {
    categoryForm.on('change', () => {
      const val = categoryForm.serializeArray();
      currFilter.category = val[0].value;
      applyCurrFilters();
    });

    const $win = $(window);
    const $body = $('body');
    const offsetFilters = 33;
    if (filterTop.length) {
      $win.on('scroll', () => {
        const scrollTop = $win.scrollTop();
        if (scrollTop >= offsetFilters) {
          $body.addClass('filters-sticky');
        } else {
          $body.removeClass('filters-sticky');
        }
      });
    }
  }

  const orderPolitician = $('.js-order-politician-btn');
  if (orderPolitician.length) {
    orderPolitician.on('click', ev => {
      ev.preventDefault();
      const curr = ev.currentTarget;
      if (!curr.classList.contains(ACTIVE)) {
        orderPolitician.removeClass(ACTIVE);
        curr.classList.add(ACTIVE);
        const order = curr.getAttribute('data-order');
        if (currFilter.order !== order) {
          currFilter.order = order;
        }
        applyCurrFilters();
      }
    });
  }
};
export default filter;



// WEBPACK FOOTER //
// ./src/scripts/modules/filter.js